import { render, staticRenderFns } from "./SmartLeadDetail.vue?vue&type=template&id=4479c1ee"
import script from "./SmartLeadDetail.vue?vue&type=script&lang=js"
export * from "./SmartLeadDetail.vue?vue&type=script&lang=js"
import style0 from "./SmartLeadDetail.vue?vue&type=style&index=0&id=4479c1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports